import useCustomerInfo from 'hooks/useCustomerInfo';
import { useMemo } from 'react';
import {
  hasRequiredRole,
  isInEnabled,
  isEnabledForEnvironment,
  mergeNavigationWithDbConfig,
} from './utils';
import { useAppSelector } from 'store/hook';

interface IUseRouteExists {
  id: string;
  forSidebar?: boolean;
}

/**
 * Checks if a route exists in the navigation map - Note: This only checks for one level deep
 * @param id - The ID of the route to check
 * @param forSidebar - Whether the route is for the sidebar
 * @returns Whether the route exists
 */
export const useRouteExists = ({ id, forSidebar = false }: IUseRouteExists) => {
  const { customerCode, role, email } = useCustomerInfo();

  const navigationConfigData = useAppSelector(
    (state) => state.navigationConfigReducer.data
  );

  const user = useMemo(() => {
    return {
      email,
      customerCode,
      roles: role ? [role] : [],
    };
  }, [email, customerCode, role]);

  const mergedStaticAndDbConfig = useMemo(() => {
    const temp = mergeNavigationWithDbConfig(navigationConfigData);
    return temp;
  }, [navigationConfigData]);

  const isRouteVisible = useMemo(() => {
    const foundPath = mergedStaticAndDbConfig.find((item) => item.id === id);
    if (!foundPath) return false;

    const isVisibleByRole = hasRequiredRole(user.roles, foundPath?.roles);

    // const isCustomerExcluded = isExcluded(
    //   foundPath?.exclude,
    //   user?.customerCode
    // );

    // if (isCustomerExcluded) return false;

    const isEnabled = isInEnabled(foundPath?.enabledFor, user?.customerCode);

    const isVisibleInEnvironment = isEnabledForEnvironment(
      foundPath?.enabledEnvironments
    );

    const visibleInSidebar = forSidebar ? foundPath?.invisible : true;

    return (
      isVisibleByRole &&
      (foundPath?.enabledFor && foundPath?.enabledFor?.length > 0
        ? isEnabled
        : true) &&
      isVisibleInEnvironment &&
      visibleInSidebar
    );
  }, []);

  return isRouteVisible;
};
